<template>
    <div id="edit_distribution">
        <div v-if="is_loading || !is_initialized">
            <div class="ui inverted dimmer transition visible active" style="display: block !important;">
                <div class="ui text loader">
                    <!-- 處理中... -->
                    {{ $t('ui.general.initializing') }}
                </div>
            </div>
        </div>
        <div v-else class="contents">
            <table class="ui fixed table form">
                <thead>
                    <tr>
                        <th class="right aligned">
                            <h3 class="ui header">
                                <input type="text" v-model="distribution.name">
                            </h3>
                        </th>
                        <th colspan="4"></th>
                        <th>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 策&emsp;&emsp;&emsp;&emsp;&emsp;略 -->
                            {{ $t('models.attributes.distributions.strategy') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <select v-dropdown v-model="distribution.strategy">
                                <option value>{{ $t('ui.general.please_select') }}</option>
                                <option v-for="strategy in strategies" :value="strategy.value">{{ strategy.name }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr v-if="distribution.strategy == 'intermodal'">
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 策&emsp;&emsp;略&emsp;&emsp;值 -->
                            {{ $t('models.attributes.distributions.strategy_value') }}
                        </td>
                        <td class="ui form" colspan="5">
                            <input type="text" v-model="distribution.strategy_value">
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 優&emsp;先&emsp;順&emsp;序 -->
                            {{ $t('models.attributes.distributions.priority') }}
                        </td>
                        <td class="ui form" colspan="5">
                            <input type="number" v-model="distribution.priority">
                        </td>
                    </tr>

                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 管&emsp;轄&emsp;站&emsp;點 -->
                            {{ $t('models.attributes.distributions.station') }}
                        </td>
                        <td class="ui form" colspan="5" style="overflow: visible;">
                            <select v-dropdown v-model="distribution.station_identity" ref="station_selector">
                                <option value>{{ $t('ui.general.please_select') }}</option>
                                <option v-for="station in stations" :value="station.identity">{{ station.name }}</option>
                            </select>
                            <button class="ui basic icon button" @click="distribution.station_identity = null; $($refs.station_selector).dropdown('clear');">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 限&emsp;定&emsp;物&emsp;料 -->
                            {{ $t('models.attributes.distributions.material') }}
                        </td>
                        <td class="ui form" colspan="5" style="overflow: visible;">
                            <select v-dropdown v-model="distribution.material_identity" ref="material_selector">
                                <option value>{{ $t('ui.general.please_select') }}</option>
                                <option v-for="material in materials" :value="material.identity">{{ material.name }}</option>
                            </select>
                            <button class="ui basic icon button" @click="distribution.material_identity = null; $($refs.material_selector).dropdown('clear');">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 啟&emsp;&emsp;&emsp;&emsp;&emsp;用 -->
                            {{ $t('models.attributes.distributions.is_activated') }}
                        </td>
                        <td class="ui form" colspan="5">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="distribution.is_activated" id="is_activated">
                                <label for="is_activated" class="pointer">
                                    <span v-if="distribution.is_activated">
                                        <!-- 已啟用 -->
                                        {{ $t('ui.pages.distributions.activated') }}
                                    </span>
                                    <span v-else>
                                        <!-- 未啟用 -->
                                        {{ $t('ui.pages.distributions.unactivated') }}
                                    </span>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            <table class="ui three column table">
                                <thead>
                                    <tr>
                                        <th>{{ $t('ui.pages.distributions.condition_type') }}</th>
                                        <th>{{ $t('ui.pages.distributions.content') }}</th>
                                        <th>
                                            <button class="ui basic positive fluid button" @click="
                                                distribution.distribution_conditions.push({
                                                    address_type: 'administrative_area_level_1',
                                                    address_name: '',
                                                    _delete: false,
                                                });">
                                                <i class="plus icon"></i>{{ $t('ui.pages.distributions.add_condition') }}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr :class="{'negative': condition._delete}" v-for="(condition, condition_index) in distribution.distribution_conditions" :key="condition.identity">
                                        <td :class="{'disabled input': condition._delete}" style="overflow: visible;">
                                            <select v-dropdown v-model="condition.address_type">
                                                <option value>{{ $t('ui.general.please_select') }}</option>
                                                <option v-for="address_type in address_types" :value="address_type.value">{{ address_type.name }}</option>
                                            </select>
                                        </td>
                                        <td :class="{'disabled input': condition._delete}">
                                            <input type="text" v-model="condition.address_name">
                                        </td>
                                        <td>
                                            <button class="ui basic fluid button" :class="{positive: condition._delete, negative: !condition._delete}" @click="condition._delete = !condition._delete">
                                                <span v-if="condition._delete">
                                                    <i class="refresh icon"></i>
                                                    <!-- 復原 -->
                                                    {{ $t('ui.pages.distributions.undo') }}
                                                </span>
                                                <span v-else>
                                                    <i class="remove icon"></i>
                                                    {{ $t('ui.general.delete') }}
                                                </span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="6">
                                            <div class="ui icon message">
                                                <i class="info icon"></i>
                                                <div class="content">
                                                    <div class="header">
                                                        <!-- 如何寫條件？ -->
                                                        {{ $t('ui.pages.distributions.add_condition_help') }}
                                                    </div>
                                                    <p> {{ $t('ui.pages.distributions.add_condition_help_content_1') }} </p>
                                                    <p> {{ $t('ui.pages.distributions.add_condition_help_content_2') }} </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            <button class="ui basic fluid positive button" @click.prevent="update_distribution">{{ $t('ui.general.update') }}</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditDistribution",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            distribution: {},
            errors: [],
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.init()
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        strategies() {
            return [
                {name: "站點直派", value: "direct"},
                {name: "轉聯運", value: "intermodal"},
            ]
        },
        stations() {
            return this.$store.state.provider.stations
        },
        materials() {
            return this.$store.state.provider.distributions_module.materials
        },
        address_types() {
            return [
                {name: "Country", value: "country"},
                {name: "直轄市", value: "administrative_area_level_1"},
                {name: "縣/省轄市", value: "administrative_area_level_2"},
                {name: "直轄市區/省轄市區/縣轄鄉鎮市", value: "administrative_area_level_3"},
                {name: "路", value: "route"},
                {name: "郵遞區號", value: "postal_code"},
            ]
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await this.fetch_distribution()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_distribution() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_distribution).parse(
                {"distribution_identity": this.$route.params.identity},
            )
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.distribution = response.data.distribution
                        _.forEach(this.distribution.distribution_conditions, distribution_condition => {
                            this.$set(distribution_condition, "_delete", false)
                        })
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("抓取分撥失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.distributions'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    this.is_loading = false
                    return response
                })
                .catch(error => {
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.distributions'),
                            reason: ': '+ this.$t('ui.general.network_abnormality') + "," + error.response.status
                        })
                    )
                    return Promise.reject(error)
                    this.is_loading = false
                })
        },
        update_distribution() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_distribution_update).parse(
                {"distribution_identity": this.$route.params.identity},
            )
            var params = _.cloneDeep(this.distribution)
            delete params.identity
            delete params.node_identity
            delete params.material
            axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
            .then(response => {
                if (response.data.status == "success") {
                    // this.$noty.success("分撥更新成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.update__name', {
                            name: this.$t('models.distributions')
                        })
                    )
                    this.init()
                } else {
                    // this.$noty.error("分撥更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.distributions'),
                            reason: ': ' + response.data.errors
                        })
                    )
                    this.errors = response.data.errors
                }
            })
            .catch(error => {
                console.log(error)
                this.$noty.error(
                    this.$t('ui.general.network_abnormality')
                )
            })
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
